/**
 * Define common utils functions here
 */

// Return if the param is null or undefined, works for all kind of types
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const isNullOrUndefined = (obj: any): obj is null | undefined => {
  return obj === null || obj === undefined;
};

export const capitalizeFirstLetter = (word: string): string =>
  word && word.charAt(0).toUpperCase() + word.slice(1);

export const isPrimeDay = ({
  today,
  startDate,
  endDate,
}: {
  today: Date;
  startDate: string;
  endDate: string;
}): boolean => {
  const cleanKeys = (value: string): string =>
    value.replace("‘", "").replace("’", "");

  const campaignStartDate = new Date(cleanKeys(startDate));
  const campaignEndDate = new Date(cleanKeys(endDate));
  return today >= campaignStartDate && today <= campaignEndDate;
};
